import script from "./SignaturesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignaturesView.vue?vue&type=script&setup=true&lang=ts"

import "./SignaturesView.vue?vue&type=style&index=0&id=86fbcd8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86fbcd8e"]])

export default __exports__